// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

export default styled<any, Theme>('button')`
  background: none;
  border: none;
  color: inherit;
  display: inline-flex;
  align-items: center;
  font-size: 1rem;
  cursor: pointer;
  padding: 0;
`;
